export const client = (state) => state.client
export const completeClient = (state) => state.completeClient
export const empresas = (state) => state.empresas
export const sucursales = (state) => state.sucursales
export const sucursal = (state) => state.sucursal
export const errorSucursal = (state) => state.errorSucursal
export const regiones = (state) => state.regiones
